export default "__VITE_ASSET__PjQ0LIqL__"